import { t } from "@lingui/macro";
import * as React from "react";
import { Circle, Path, Defs, ClipPath, G } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const DrizzleIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Drizzle`} {...props}>
    <G clipPath="url(#a)">
      <Path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M11.5 10c1.932 0 3.5-1.512 3.5-3.375S13.432 3.25 11.5 3.25c-.571 0-1.115.14-1.592.375C9.17 2.078 7.548 1 5.667 1 3.09 1 1 3.016 1 5.5c0 1.758 1.046 3.28 2.57 4.021"
        fill="none"
      />
      <Circle cx={6.5} cy={12} r={1} fill="currentColor" />
      <Circle cx={9.5} cy={11} r={1} fill="currentColor" />
      <Circle cx={6.5} cy={9} r={1} fill="currentColor" />
      <Circle cx={9.5} cy={8} r={1} fill="currentColor" />
      <Circle cx={9.5} cy={14} r={1} fill="currentColor" />
      <Circle cx={6.5} cy={15} r={1} fill="currentColor" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);

export default DrizzleIcon;
